<template>
  <BaseButton theme="default"
              @click="$router.push({name:'create-accounting'})">
      <span class="flex items-center justify-center">
        <IconAddSpace class="text-icon"/><span class="ml-4 text-sm font-medium">{{ $t('createSpace') }}</span>
      </span>
  </BaseButton>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import IconAddSpace from "@/components/icons/IconAddSpace";

export default {
  name: "SpaceSettingsCreateBtn",
  components: {IconAddSpace, BaseButton},
  i18n: {
    messages: {
      en: {
        createSpace: 'New accounting system'
      },
      ru: {
        createSpace: 'Новая система учета'
      }
    }
  }
}
</script>

<style scoped>
.button {
  @apply h-14;
}
</style>